import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const styles = {
  main: {
    paddingLeft: 0,
    paddingRight: 0
  },
  icon: {
    width: 20
  }
};

const enhance = compose();

const button = enhance(({ onClickAction, classes, disabled }) => {
  return (
    <Button
      disabled={disabled}
      className={classes.main}
      color="primary"
      onClick={onClickAction}
    >
      <AddCircleIcon className={classes.icon} />
      &nbsp;画像アップロードの追加
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
